import axios from "../axios";

const generateAnnualReturn = (data) => {
  return axios.post("/annual-returns/generate-annual-returns", data);
};

export const generateAnnualReturnDataService = {
  create: generateAnnualReturn,
};
